export default function initializeWooSliders() {
    const productLists = document.querySelectorAll('.wc-block-product-template');
    if (!productLists.length) return;

    import('swiper').then(({ default: Swiper }) => {
        productLists.forEach((list, index) => {
            const { swiperContainer, prevBtn, nextBtn } = setupSliderDOM(list, index);


            const swiper = new Swiper(swiperContainer, {
                slidesPerView: 4,
                spaceBetween: 0,
                loop: true,
                breakpoints: {
                    1200: { slidesPerView: 4 },
                    992: { slidesPerView: 3 },
                    480: { slidesPerView: 2 },
                    0: { slidesPerView: 2 }
                }
            });


            prevBtn.addEventListener('click', () => {
                swiper.slidePrev();
            });

            nextBtn.addEventListener('click', () => {
                swiper.slideNext();
            });
        });
    });
}

function setupSliderDOM(list, index) {
    if (list.classList.contains('swiper-wrapper')) return;

    list.classList.remove('is-flex-container', 'columns-4');
    list.classList.add('swiper-wrapper');

    list.querySelectorAll('.wc-block-product').forEach(item => {
        item.classList.add('swiper-slide');
        item.style.flexShrink = '0';
    });

    const parent = list.parentElement;
    if (!parent) return;

    const swiperContainer = document.createElement('div');
    swiperContainer.classList.add('swiper-container', `bestseller-swiper-${index}`);
    parent.replaceChild(swiperContainer, list);
    swiperContainer.appendChild(list);

    const prevBtn = document.createElement('div');
    const nextBtn = document.createElement('div');
    prevBtn.classList.add('swiper-button-prev');
    nextBtn.classList.add('swiper-button-next');

    swiperContainer.appendChild(prevBtn);
    swiperContainer.appendChild(nextBtn);

    return { swiperContainer, prevBtn, nextBtn };
}
